export const getResolution = () => {
  if (window.matchMedia('(min-width: 768px)').matches) {
    return 'desktop';
  }
  return 'mobile';
};
